import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IUserMinify } from "../interface/user/IUserMinify";
import { UserTypeEnum } from "../enum/UserTypeEnum";
import { generateQueryString } from "src/util/helper";
import { ICommonDomain } from "../interface/ICommonDomain";
import { IUser } from '../interface/user/IUser';

enum UserServiceEnum {
  getProfile = "/profile",
  save = "",
  getById = "/",
  getAll = "/",
  getTypes = "/types",
  getUsersByType = "/get-users-by-type?",
  getUserAlreadyResetPassword = "/user-already-reset-password",
  getMigrationPasswordChange = "/migration-password-change",
  setUserAlreadyResetPassword = "/set-user-already-reset-password",
  resetPasswodCognito = '/reset-password'
}

export default class UserService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/user");
  }

  public getProfile = async () => await this.GET(UserServiceEnum.getProfile);
  public save = async data => await this.POST(UserServiceEnum.save, data);
  public getById = async (id: number): Promise<IUser> => await this.GET(UserServiceEnum.getById + id);
  public getAll = async () => await this.GET(UserServiceEnum.getAll);
  public getTypes = async () => await this.GET(UserServiceEnum.getTypes);
  public getUsersByType = async (userType: UserTypeEnum): Promise<IUserMinify[]> => await this.GET(`${UserServiceEnum.getUsersByType}${generateQueryString({ userType })}`);
  public getUserAlreadyResetPassword = async (login: string): Promise<boolean> => await this.GET(`${UserServiceEnum.getUserAlreadyResetPassword}?login=${encodeURIComponent(login)}`);
  public setUserAlreadyResetPassword = async (login: string): Promise<boolean> => await this.GET(`${UserServiceEnum.setUserAlreadyResetPassword}?login=${encodeURIComponent(login)}`);

  public getMigrationPasswordChange = async (): Promise<ICommonDomain> => await this.GET(UserServiceEnum.getMigrationPasswordChange);

  public resetPasswordCognito = async (login: string): Promise<boolean> => await this.GET(`${UserServiceEnum.resetPasswodCognito}?login=${encodeURIComponent(login)}`);
}
